/**
 * Do not edit directly
 */

export default "PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTggMi41di0xLjVsLTIgMiAyIDJ2LTEuNWE0LjUgNC41IDAgMSAxIC00LjUgNC41aC0xYTUuNSA1LjUgMCAxIDAgNS41LTUuNXoiLz48L3N2Zz4=";